import React from "react";
import { IconProps } from "./IconProps";

const Tick: React.FC<IconProps> = ({
  size = 22,
  color = "#F7F9F9",
  ...props
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        d="M16.6663 4.1665L7.49967 13.3332L3.33301 9.1665"
        stroke="white"
        strokeWidth="1.67"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Tick;
